import axios from '../../v2/app/services/axiosService';
import moment from 'moment';

export default {
  async getContact(contactUUID) {
    const response = await axios.get(`/api/analytics/contacts/${contactUUID}`);
    return response.data;
  },
  async enrichContact(contactUUID) {
    const response = await axios.get(`/api/analytics/contacts/${contactUUID}/enrich`);
    return response.data;
  },
  async getContactReport(presentationID, contactUUID) {
    const response = await axios.get(`/api/analytics/presentations/${presentationID}/contacts/${contactUUID}`);
    return response.data;
  },
  async getContactsReport(presentationID, form) {
    const options = {
      params: form,
    };
    const response = await axios.get(`/api/analytics/presentations/${presentationID}/contacts`, options);
    return response.data;
  },
  async getPagesReport(presentationID, form) {
    const options = {
      params: form,
    };
    const response = await axios.get(`/api/analytics/presentations/${presentationID}/pages`, options);
    return response.data;
  },
  async getLinksReport(presentationID, form) { // MLD-2596
    const options = {
      params: form,
    };
    const response = await axios.get(`/api/analytics/presentations/${presentationID}/links`, options);
    return response.data;
  },
  async creatSessionForActivity(activityID) {
    const form = {
      activity_id: activityID,
    }
    const response = await axios.post(`/api/sessions`, form);
    return response.data;
  },
  async createSessionForHit(hitUUID, recaptchaResult) {
    const form = {
      hit_uuid: hitUUID,
      live_mode: true, // MLD-5088
      recaptcha: recaptchaResult, // MLD-5215
    };
    const response = await axios.post(`/api/sessions`, form);
    return response.data;
  },
  async pingSession(sessionID, meta, elapsedMS) { // MLD-4832
    const form = {
      elapsed_ms: elapsedMS,
      ended_at: moment().format(),
      meta,
    };
    const response = await axios.put(`/api/sessions/${sessionID}/ping`, form);
    return response.data;
  },
  async endSession(sessionID, form = {}) {
    const response = await axios.put(`/api/sessions/${sessionID}/end`, form);
    return response.data;
  },
  async getSessions(params = {}) { // MLD-2534
    const response = await axios.get(`/api/sessions`, {params});
    return response.data;
  },
  exportSessions(form = {}) { // MLD-4588
    // TODO
  },
  async getSession(sessionID) {
    const response = await axios.get(`/api/sessions/${sessionID}`);
    return response.data;
  },
  async getEvents(form) {
    const response = await axios.get(`/api/events`, {params: form});
    return response.data;
  },
  /**
   * @param {number} sessionID
   * @param {number} pageNumber
   * @param {object} sessionMeta
   * @returns {Promise<any>}
   */
  async changePDFPage(sessionID, pageNumber, sessionMeta = {}) {
    const form = {
      event_at_ms: Date.now(),
      category: 'PDF',
      action: 'change_page',
      path: `${pageNumber}`.padStart(4, '0'),
      meta: sessionMeta,
    };
    return await this.createEvent(sessionID, form);
  },
  async createEvent(sessionID, form) {
    if (!form.event_at_ms) {
      form.event_at_ms = Date.now();
    }
    const response = await axios.post(`/api/sessions/${sessionID}/events`, form);
    return response.data;
  },
  async getEvent(eventID) {
    const response = await axios.get(`/api/events/${eventID}`);
    return response.data;
  },
}
